import { Skeleton } from '@/components/ui';

export function TopBarSkeleton() {
  return (
    <div className="flex items-center gap-2.5 px-4 h-[49px]">
      <Skeleton className="size-[50px] rounded-full" />
      <Skeleton className="flex-1 h-12 rounded-[31px]" />
      <Skeleton className="w-[86px] h-[49px] rounded-[63px]" />
    </div>
  );
}
